import { filterObjectByFields } from './../utils/functions'

class JoinUsService {
  async getPositions() {
    try {
      const res = await fetch('/api/v1/joinus/positions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
      const positions = await res.json()
      return positions
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async getLastProfile() {
    try {
      const res = await fetch('/api/v1/joinus/lastProfile', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
      const profile = await res.json()
      return profile
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async saveRecruitment(data) {
    console.log('Data', data)

    const recruitmentObj = this.mapCheckboxValues(data)

    console.log('Mapped Data', recruitmentObj)

    try {
      const res = await fetch('/api/v1/joinus/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(recruitmentObj),
        credentials: 'same-origin',
      })

      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async submitRecruitment(data) {
    console.log('Data', data)

    const recruitmentObj = this.mapCheckboxValues(data)

    console.log('Mapped Data', recruitmentObj)

    try {
      const res = await fetch('/api/v1/joinus/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(recruitmentObj),
        credentials: 'same-origin',
      })

      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async uploadFile(options, recruitId, fileType) {
    console.log('OPTIONS', options)

    const formData = new FormData()

    formData.set('files', options.file, options.file.name)
    formData.set('recruitId', recruitId)
    formData.set('fileType', fileType)

    try {
      const res = await fetch('/api/v1/joinus/upload', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })

      const json = await res.json()
      options.onSuccess(json.data, options.file)
      console.log('Success: ', JSON.stringify(json))

      if (json.rspCode === 'ok') {
        return json.files[0]
      } else {
        return
      }
    } catch (err) {
      console.error('Error: ', err)
      options.onError(err)
    }
  }

  getProfileContactData(recruitmentData) {
    const fields = [
      'name',
      'nationality',
      'qualification',
      'countryofexperience',
      'yearsofexperience',
      'phone',
      'email',
      'location',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getMainExperiencePositionData(recruitmentData) {
    const fields = [
      'checkboxNGOs',
      'checkboxUNs',
      'checkboxDonors',
      'checkboxConsultancyGroup',
      'NGOs',
      'UNs',
      'donors',
      'consultant',
      'agency',
      'position',
      'English',
      'Swahili',
      'Arabic',
      'Portuguese',
      'French',
      'Spanish',
      'Somali',
      'otherlang',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getCandidateExperienceDetailsData(recruitmentData) {
    const fields = [
      'assessment',
      'Proposal',
      'Program',
      'baseline',
      'MidEval',
      'FinEval',
      'research',
      'Training',
      'Monitoring',
      'ThirdPartyMonitoring',
      'Survey',
      'ImpactAssessment',
      'Flood',
      'Drought',
      'Tsunami',
      'Displaced',
      'Conflict',
      'Epidemic',
      'development',
      'othercrisis',
      'ClientNGO',
      'EU',
      'DFID',
      'USAID',
      'DANIDA',
      'SIDA',
      'CIDA',
      'NORAD',
      'AusAID',
      'JICA',
      'UNDP',
      'WFP',
      'WB',
      'HCR',
      'UNICEF',
      'OtherUNAgencies',
      'UNHABITAT',
      'otherClients',
      'ME',
      'WaterandSanitation',
      'Protection',
      'Livelihood',
      'GIS',
      'Finance',
      'Logistic',
      'HumanRight',
      'Advocacy',
      'HIV',
      'Gender',
      'environment',
      'Health',
      'Agriculture',
      'Nutrition',
      'Governance',
      'Poverty',
      'Administration',
      'Education',
      'Business',
      'Distribution',
      'Livestock',
      'Stabilization',
      'Resilience',
      'Security',
      'DataManagement',
      'Sampling',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getSupportingDocumentsData(recruitmentData) {
    const fields = ['_id', 'fileCV', 'fileCL', 'fileRI']

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  mapCheckboxValues(data) {
    let recruitmentObj = {}

    for (let [key, value] of Object.entries(data)) {
      if (value === true) {
        value = 'OK'
      }

      if (value === false) {
        value = ''
      }

      recruitmentObj[key] = value
    }

    return recruitmentObj
  }
}

const joinUsService = new JoinUsService()

export default joinUsService
